"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_uid_1 = require("react-uid");
var change_case_1 = require("change-case");
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var StyledSVG = styled_1.default.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var size = _a.size;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n  "], ["\n    width: ", "px;\n    height: ", "px;\n  "])), size, size);
});
var createIcon = function (name, render, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.viewBox, dViewBox = _c === void 0 ? '0 0 20 20' : _c, _d = _b.size, dSize = _d === void 0 ? 20 : _d, _e = _b.color, dColor = _e === void 0 ? 'currentColor' : _e, _f = _b.secondaryColor, dSecondaryColor = _f === void 0 ? 'currentColor' : _f;
    var Component = react_1.forwardRef(function (_a, ref) {
        var _b = _a.viewBox, viewBox = _b === void 0 ? dViewBox : _b, _c = _a.size, size = _c === void 0 ? dSize : _c, colorProp = _a.color, colorType = _a.colorType, secondaryColorProp = _a.secondaryColor, secondaryColorType = _a.secondaryColorType, props = __rest(_a, ["viewBox", "size", "color", "colorType", "secondaryColor", "secondaryColorType"]);
        var genId = react_uid_1.useUIDSeed();
        var color = fallback_1.default(ThemeProvider_1.useColor(colorProp, colorType), dColor);
        var secondaryColor = fallback_1.default(ThemeProvider_1.useColor(secondaryColorProp, secondaryColorType), dSecondaryColor);
        return (react_1.default.createElement(StyledSVG, __assign({ ref: ref, size: size, viewBox: viewBox, "aria-label": !props['aria-hidden'] ? change_case_1.paramCase(name) : undefined }, props), render(__assign({ color: color, secondaryColor: secondaryColor, genId: genId }, props))));
    });
    Component.displayName = name;
    return Component;
};
exports.default = createIcon;
var templateObject_1, templateObject_2;
